import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, X } from 'lucide-react';
import { useAuthStore } from '@shared/state';
import { getUnacknowledgedCount, acknowledgeAllPending } from '@shared/services/adaptationHistory';
import { THICK_TILE_SHADOW } from './tileStyles';

export function UnacknowledgedChangesBanner() {
  const user = useAuthStore((s) => s.user);
  const [count, setCount] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user) return;
    getUnacknowledgedCount(user.uid)
      .then(setCount)
      .catch(() => setCount(0));
  }, [user]);

  if (!user || count === 0 || dismissed) return null;

  async function handleDismiss() {
    setDismissed(true);
    try {
      await acknowledgeAllPending(user!.uid);
    } catch { /* best effort */ }
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -6 }}
      animate={{ opacity: 1, y: 0 }}
      className="rounded-xl border-l-[3px] border-l-gold-500 bg-gold-500/[0.06] border border-gold-500/15 p-4 flex items-center justify-between gap-3"
      style={{ boxShadow: THICK_TILE_SHADOW }}
    >
      <div className="flex-1 min-w-0">
        <p className="text-sm text-content font-body">
          Your CogniPrint has been updated.{' '}
          <Link
            to="/profile/adaptations"
            className="text-indigo-400 hover:text-indigo-300 inline-flex items-center gap-1"
          >
            Review what changed <ArrowRight size={10} />
          </Link>
        </p>
      </div>
      <button
        type="button"
        onClick={handleDismiss}
        className="p-1 text-content-dim hover:text-content transition-colors shrink-0 cursor-pointer"
        aria-label="Dismiss"
      >
        <X size={14} />
      </button>
    </motion.div>
  );
}
